import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslationsService } from 'src/app/translations/translations.service';
import { WidgetCardColumn, WidgetCardConfig } from 'src/app/core/models/patient-app-widget.model';

@Component({
  selector: 'csi-patient-app-expanded-modal',
  templateUrl: './patient-app-expanded-modal.component.html',
  styleUrls: ['./patient-app-expanded-modal.component.scss']
})
export class PatientAppExpandedModalComponent implements OnInit {
  card: WidgetCardConfig = this.data;
  public readonly translocoFileKey = 'dashboard.';
  columnDefs: string[] = [];
  displayedContent: WidgetCardColumn[] = [];
  lowerCaseTitle = '';
  page = 0;
  pageSize = 15;
  maxPages = 1;
  slicedData: unknown[][] = [];

  constructor(
    public dialogRef: MatDialogRef<PatientAppExpandedModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: WidgetCardConfig,
    public translationsService: TranslationsService
  ) {}

  ngOnInit() {
    this.page = 0;
    this.displayedContent = this.card.expandedContent || this.card.content || [];
    this.columnDefs = this.displayedContent.map(col => col.heading);
    this.lowerCaseTitle = this.card.title ? this.card.title.toLowerCase() : '';
    this.slicedData = this.chunkArray(this.card.data || [], this.pageSize);
    this.maxPages = Math.max(0, this.slicedData.length - 1);
  }

  chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  trackByHeading(index: number, col: WidgetCardColumn): string {
    return col.heading;
  }

  onRowClick(row: unknown) {
    if (this.card.clickable && typeof this.card.clickable.action === 'function') {
      this.card.clickable.action(row);
    }
    this.dialogRef.close();
  }

  nextPage() {
    if (this.page < this.maxPages) {
      this.page++;
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
    }
  }

  public static open(matDialogService: MatDialog, card: WidgetCardConfig) {
    return matDialogService.open(PatientAppExpandedModalComponent, {
      data: card,
      width: '900px'
    });
  }
}
